import { useMutation, useQuery } from '@tanstack/react-query';

import { queryKeys } from '@sshop/api-client';
import type { ContactSubmission } from '@sshop/domain';

import { api } from '@/shared/lib/apiClient';
import { defineQuery } from '@/shared/lib/queryFactory';

export const contactListQuery = () =>
  defineQuery({
    queryKey: queryKeys.contact.list(),
    queryFn: ({ signal }) => api.contact.list(signal),
    staleTime: 5 * 60_000,
  });

export const useContactList = () => useQuery(contactListQuery());

export const useSubmitContact = () =>
  useMutation({ mutationFn: (input: ContactSubmission) => api.contact.submit(input) });
